import { HttpClient, provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { createFoxpostTranslateLoader } from './core/i18n/FoxpostTranslateLoader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createFoxpostTranslateLoader,
          deps: [HttpClient],
        },
      }),
    ]),
  ],
};
